import React from "react";
import { Row, Col, Container, Button, Card, CardBody, ListGroup, ListGroupItem } from "reactstrap";
import Header from "components/Headers/Header";
import ScrollSignPicture from "../../assets/img/custom/Order-Sign-picture.jpg";

const ScrollSign = () => {
  const isSmallScreen = window.innerWidth < 768;

  return (
    <>
      <Header />
      <Container fluid className="mt--4">
        <Card className="shadow border-0 rounded-4 overflow-hidden mb-4">
          {/* Header */}
          <div className="bg-gradient-primary p-4 text-white">
            <span className="text-uppercase tracking-wider font-weight-600 text-white-50" style={{ fontSize: "10px", letterSpacing: "1.5px" }}>
              BRAND AMBASSADOR
            </span>
            <h2 className="text-white mb-0 mt-1 font-weight-700">
              Become an Ambassador the Easy Way
            </h2>
            <p className="text-white-50 mb-0 mt-2" style={{ fontSize: "0.95rem" }}>
              Promote your profile physically! Order a custom scroll sign or poster and share your FHP registration details with fans.
            </p>
          </div>
          
          <CardBody className="p-4" style={{ backgroundColor: "#f8fafc" }}>
            <Row className="d-flex align-items-stretch">
              {/* Left Column: Stepper instructions */}
              <Col lg="6" className="mb-4 mb-lg-0">
                <div className="bg-white p-4 rounded-4 shadow-sm h-100">
                  <h3 className="h4 text-dark font-weight-700 mb-4">
                    <i className="fas fa-tasks text-primary mr-2"></i> Step-by-Step Instructions
                  </h3>
                  
                  <ListGroup className="list-group-flush">
                    {[
                      "Order this scroll sign or poster.",
                      "Display your sign or poster to fans.",
                      "Give fans your card containing your name and FHP registration number.",
                      "Document your work: ask a friend to take your photo as you display the sign to fans."
                    ].map((step, idx) => (
                      <ListGroupItem key={idx} className="border-0 px-0 py-3 d-flex align-items-start bg-transparent">
                        <span 
                          className="d-flex align-items-center justify-content-center bg-primary text-white rounded-circle mr-3 font-weight-bold"
                          style={{
                            minWidth: "30px",
                            height: "30px",
                            fontSize: "13px",
                            boxShadow: "0 2px 4px rgba(94, 114, 228, 0.2)"
                          }}
                        >
                          {idx + 1}
                        </span>
                        <span className="text-dark font-weight-500 pt-1" style={{ fontSize: "0.95rem", lineHeight: "1.4" }}>
                          {step}
                        </span>
                      </ListGroupItem>
                    ))}
                  </ListGroup>
                </div>
              </Col>

              {/* Right Column: Preview & Action */}
              <Col lg="6">
                <div className="bg-white p-4 rounded-4 shadow-sm text-center h-100 d-flex flex-column justify-content-between">
                  <div>
                    <h4 className="text-muted font-weight-600 mb-3" style={{ fontSize: "0.9rem" }}>
                      PREVIEW OF SCROLL SIGN
                    </h4>
                    <div className="border rounded-3 overflow-hidden shadow-inner bg-light p-2 mb-4">
                      <img
                        src={ScrollSignPicture}
                        alt="Scroll Sign Preview"
                        className="img-fluid rounded-2"
                        style={{ maxHeight: "250px", width: "100%", objectFit: "contain" }}
                      />
                    </div>
                  </div>
                  
                  <div className="mt-3">
                    <Button
                      color="primary"
                      size="lg"
                      className="rounded-pill px-5 shadow font-weight-bold"
                      onClick={() =>
                        window.open("https://fans-help-players-athlete.web.app/shop", "_blank")
                      }
                    >
                      <i className="fas fa-shopping-cart mr-2"></i> Order Now
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default ScrollSign;
